import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import * as Text from "@/components/text";
import Link from "next/link";
import breakpoints from "@/constants/breakpoinst";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { format } from "date-fns";
import EventCard from "@/components/event/EventCard";
import { getTodayEvents } from "@/actions/eventsActions";
import { localeTexts } from "@/utils/locale";
import { useRouter } from "next/router";

export default function TodayShows() {
  const [todayEvents, setTodayEvents] = useState([]);
  const router = useRouter();
  const [locale, setLocale] = useState("es-MX");

     useEffect(() => {
     if (!router.isReady) return;
     const urlLocale = router.query.locale;
     const storedLocale = typeof window !== "undefined"
     ? localStorage.getItem("amb-locale")
     : null;
     
     const finalLocale = urlLocale || storedLocale || "es-MX";
     setLocale(finalLocale);
     localStorage.setItem("amb-locale", finalLocale);
     }, [router.isReady, router.query.locale]);

  useEffect(() => {
    getTodayEvents().then((response) => {
      setTodayEvents(response.data.data);
    });
  }, []);

  if (todayEvents.length === 0) return null;
  return (
    <div className="bg-neutral-50 p-3">
      <div className="amb-container flex flex-row items-end justify-between ">
        <Text.Headline className="sm:text-[24px]" size="md" as="h3">
          {localeTexts[locale].Films.today}
        </Text.Headline>

        <Link href="/iniciativas/gira?seccion=gira-presencial">
          <button className="border-b-2 border-solid border-gray-500/50 font-semibold">
            {localeTexts[locale].Films.calendario}
          </button>
        </Link>
      </div>

      <div className="amb-container my-10  ">
        <Swiper
          breakpoints={{
            [breakpoints.xl]: {
              slidesPerView: 4.2,
              slidesPerGroup: 4,
              spaceBetween: 24,
            },
            [breakpoints.lg]: {
              slidesPerView: 4.2,
              slidesPerGroup: 4,
              spaceBetween: 24,
            },
            [breakpoints.md]: {
              slidesPerView: 3.2,
              slidesPerGroup: 3,
              spaceBetween: 24,
            },
            [breakpoints.sm]: {
              slidesPerView: 1.5,
              slidesPerGroup: 1,
              spaceBetween: 16,
            },
          }}
        >
          {todayEvents.map((projection) => (
            <SwiperSlide key={projection.id}>
              <div>
                <EventCard
                  key={projection.id}
                  size={"md"}
                  event_type={projection.attributes.event_type}
                  event_title={projection.attributes.event_name}
                  date_time={projection.attributes.date_time}
                  event_state={
                    projection?.attributes?.sede?.data?.attributes?.states
                  }
                  event_venue={
                    projection?.attributes?.sede?.data?.attributes?.name
                  }
                  event_image_url={
                    projection?.attributes?.event_image?.data?.attributes?.url
                  }
                  event_url={`/calendario/${projection.id}`}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
